import { useState } from 'react';

import axios, { AxiosInstance } from 'axios';

type FileDownloadState = {
  data: BlobPart;
  error: string;
  isFileDownloaded: boolean;
  loading: boolean;
  statusCode: number;
};
type FileDownloadHookState = FileDownloadState & {
  sendRequest: (params: SendFileDownloadRequestParams) => Promise<void>;
};

type SendFileDownloadRequestParams = {
  url: string;
};

const defaultState: FileDownloadState = {
  data: null,
  error: null,
  isFileDownloaded: false,
  loading: false,
  statusCode: null,
};

const axiosInstance: AxiosInstance = axios.create();

const useS3FileDownload = (): FileDownloadHookState => {
  const [state, setState] = useState<FileDownloadState>(defaultState);

  const sendRequest = async ({ url }) => {
    setState({
      ...defaultState,
      loading: true,
    });

    const newState: FileDownloadState = {
      ...defaultState,
    };

    try {
      const { data, status } = await axiosInstance.get(url, {
        headers: {
          'Cache-Control': 'no-cache',
        },
        responseType: 'arraybuffer',
      });

      newState.data = data;
      newState.statusCode = status;
      newState.isFileDownloaded = status === 200;
    } catch (err) {
      newState.statusCode = 500;
    }
    newState.error =
      newState.statusCode === 200 ? null : 'Unable to download file.';

    setState(newState);
  };

  return {
    ...state,
    sendRequest,
  };
};

export default useS3FileDownload;
